// import car1 from "../../assets/images/car1.png";
import arrow from "../../assets/images/arrow.svg"
import car1 from "../../assets/images/newcar.png";
// import car1 from "../../assets/images/newcar.webp";
import search from "../../assets/images/search.svg";
import bordercall from "../../assets/images/bordercall.svg";
import cardpay from "../../assets/images/cardpay.svg";
import solardiploma from "../../assets/images/solardiploma.svg";
import { Helmet } from "react-helmet";
// import yellowstar from "../../assets/images/yellowstar.svg";
// import reviews from "../../assets/images/reviews.svg";
// import starfull from "../../assets/images/starfull.svg";
// import carpng from "../../assets/images/car.png";
// import solarround from "../../assets/images/solarround.svg";
// import homeVal from "../../assets/images/homeVal.png";
// import homeSell from "../../assets/images/homeSell.png";
import { Suspense, lazy, useContext, useEffect, useRef, useState } from "react";
// import Swiper core and required modules
import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { useNavigate, Link } from "react-router-dom";
import { API } from "../../utils/api";
import { DataContext } from "../../context/dataContext";
import Loader from "../../components/Loader";
import { LazyLoadImage } from 'react-lazy-load-image-component';
// import { isPlainObject } from "jquery";

// const car1 = lazy(() => import("../../assets/images/newcar.png"));
// const search = lazy(() => import("../../assets/images/search.svg"));
// const bordercall = lazy(() => import("../../assets/images/bordercall.svg"));
// const cardpay = lazy(() => import("../../assets/images/cardpay.svg"));
// const solardiploma = lazy(() => import("../../assets/images/solardiploma.svg"));

const Home = () => {
  const navigate = useNavigate();
  const swiperRef = useRef();
  const [windowSize, setWindowSize] = useState([
    window.innerWidth,
    window.innerHeight,
  ]);
  const [searchKey, setSearchKey] = useState("");
  const [homeData, setHomeData] = useState();
  const dataContext = useContext(DataContext);
  useEffect(() => {
    getHomeData();
    const handleWindowResize = () => {
      setWindowSize([window.innerWidth, window.innerHeight]); //set size in state
    };
    // handleWindowResize()
    // console.log("screen size",windowSize)
    window.addEventListener("resize", handleWindowResize);

    const script = document.createElement("script");
    script.src =
      "https://widget.reviews.io/carousel-inline-iframeless/dist.js?_t=2023122906";
    script.async = true;
    document.body.appendChild(script);

    const options = {
      /*Your REVIEWS.io account ID:*/
      store: "reg247.co.uk",
      sku: "",
      lang: "en",
      carousel_type: "default",
      styles_carousel: "CarouselWidget--sideHeader",

      /*Widget settings:*/
      options: {
        general: {
          /*What reviews should the widget display? Available options: company, product, third_party. You can choose one type or multiple separated by comma.*/
          review_type: "company, product",
          /*Minimum number of reviews required for widget to be displayed*/
          min_reviews: "1",
          /*Maximum number of reviews to include in the carousel widget.*/
          max_reviews: "20",
          address_format: "CITY, COUNTRY",
          /*Carousel auto-scrolling speed. 3000 = 3 seconds. If you want to disable auto-scroll, set this value to false.*/
          enable_auto_scroll: 10000,
        },
        header: {
          /*Show overall rating stars*/
          enable_overall_stars: true,
          rating_decimal_places: 2,
        },
        reviews: {
          /*Show customer name*/
          enable_customer_name: true,
          /*Show customer location*/
          enable_customer_location: true,
          /*Show "verified review" badge*/
          enable_verified_badge: true,
          /*Show "verified subscriber" badge*/
          enable_subscriber_badge: true,
          /*Show "I recommend this product" badge (Only for product reviews)*/
          enable_recommends_badge: true,
          /*Show photos attached to reviews*/
          enable_photos: true,
          /*Show videos attached to reviews*/
          enable_videos: true,
          /*Show when review was written*/
          enable_review_date: true,
          /*Hide reviews written by the same customer (This may occur when customer reviews multiple products)*/
          disable_same_customer: true,
          /*Minimum star rating*/
          min_review_percent: 4,
          /*Show 3rd party review source*/
          third_party_source: true,
          /*Hide reviews without comments (still shows if review has a photo)*/
          hide_empty_reviews: true,
          /*Show product name*/
          enable_product_name: true,
          /*Show only reviews which have specific tags (multiple semicolon separated tags allowed i.e tag1;tag2)*/
          tags: "",
          /*Show branch, only one input*/
          branch: "",
          enable_branch_name: false,
        },
        popups: {
          /*Make review items clickable (When they are clicked, a popup appears with more information about a customer and review)*/
          enable_review_popups: true,
          /*Show "was this review helpful" buttons*/
          enable_helpful_buttons: true,
          /*Show how many times review was upvoted as helpful*/
          enable_helpful_count: true,
          /*Show share buttons*/
          enable_share_buttons: true,
        },
      },
      translations: {
        verified_customer: "Verified Customer",
      },
      styles: {
        /*Base font size is a reference size for all text elements. When base value gets changed, all TextHeading and TexBody elements get proportionally adjusted.*/
        "--base-font-size": "16px",
        "--base-maxwidth": "100%",

        /*Logo styles:*/
        "--reviewsio-logo-style": "var(--logo-normal)",

        /*Star styles:*/
        "--common-star-color": " #FDD405",
        "--common-star-disabled-color": " rgba(0,0,0,0.25)",
        "--medium-star-size": " 22px",
        "--small-star-size": "19px" /*Modal*/,
        "--x-small-star-size": "16px",
        "--x-small-star-display": "inline-flex",

        /*Header styles:*/
        "--header-order": "1",
        "--header-width": "160px",
        "--header-bg-start-color": "transparent",
        "--header-bg-end-color": "transparent",
        "--header-gradient-direction": "135deg",
        "--header-padding": "0.5em",
        "--header-border-width": "0px",
        "--header-border-color": "rgba(0,0,0,0.1)",
        "--header-border-radius": "0px",
        "--header-shadow-size": "0px",
        "--header-shadow-color": "rgba(0, 0, 0, 0.1)",

        /*Header content styles:*/
        "--header-star-color": "inherit",
        "--header-disabled-star-color": "inherit",
        "--header-heading-text-color": "inherit",
        "--header-heading-font-size": "inherit",
        "--header-heading-font-weight": "inherit",
        "--header-heading-line-height": "inherit",
        "--header-heading-text-transform": "inherit",
        "--header-subheading-text-color": "inherit",
        "--header-subheading-font-size": "inherit",
        "--header-subheading-font-weight": "inherit",
        "--header-subheading-line-height": "inherit",
        "--header-subheading-text-transform": "inherit",

        /*Review item styles:*/
        "--item-maximum-columns": "5" /*Must be 3 or larger*/,
        "--item-background-start-color": "transparent",
        "--item-background-end-color": "transparent",
        "--item-gradient-direction": "135deg",
        "--item-padding": "0.5em",
        "--item-border-width": "0px",
        "--item-border-color": "rgba(0,0,0,0.1)",
        "--item-border-radius": "0px",
        "--item-shadow-size": "0px",
        "--item-shadow-color": "rgba(0,0,0,0.1)",

        /*Heading styles:*/
        "--heading-text-color": " #0E1311",
        "--heading-text-font-weight": " 600",
        "--heading-text-font-family": " inherit",
        "--heading-text-line-height": " 1.4",
        "--heading-text-letter-spacing": "0",
        "--heading-text-transform": "none",

        /*Body text styles:*/
        "--body-text-color": " #0E1311",
        "--body-text-font-weight": "400",
        "--body-text-font-family": " inherit",
        "--body-text-line-height": " 1.4",
        "--body-text-letter-spacing": "0",
        "--body-text-transform": "none",

        /*Scroll button styles:*/
        "--scroll-button-icon-color": "#0E1311",
        "--scroll-button-icon-size": "24px",
        "--scroll-button-bg-color": "transparent",

        "--scroll-button-border-width": "0px",
        "--scroll-button-border-color": "rgba(0,0,0,0.1)",

        "--scroll-button-border-radius": "60px",
        "--scroll-button-shadow-size": "0px",
        "--scroll-button-shadow-color": "rgba(0,0,0,0.1)",
        "--scroll-button-horizontal-position": "0px",
        "--scroll-button-vertical-position": "0px",

        /*Badge styles:*/
        "--badge-icon-color": "#0E1311",
        "--badge-icon-font-size": "15px",
        "--badge-text-color": "#0E1311",
        "--badge-text-font-size": "inherit",
        "--badge-text-letter-spacing": "inherit",
        "--badge-text-transform": "inherit",

        /*Author styles:*/
        "--author-font-size": "inherit",
        "--author-font-weight": "inherit",
        "--author-text-transform": "inherit",

        /*Product photo or review photo styles:*/
        "--photo-video-thumbnail-size": "60px",
        "--photo-video-thumbnail-border-radius": "0px",

        /*Popup styles:*/
        "--popup-backdrop-color": "rgba(0,0,0,0.75)",
        "--popup-color": "#ffffff",
        "--popup-star-color": "inherit",
        "--popup-disabled-star-color": "inherit",
        "--popup-heading-text-color": "inherit",
        "--popup-body-text-color": "inherit",
        "--popup-badge-icon-color": "inherit",
        "--popup-badge-icon-font-size": "19px",
        "--popup-badge-text-color": "inherit",
        "--popup-badge-text-font-size": "14px",
        "--popup-border-width": "0px",
        "--popup-border-color": "rgba(0,0,0,0.1)",
        "--popup-border-radius": "0px",
        "--popup-shadow-size": "0px",
        "--popup-shadow-color": "rgba(0,0,0,0.1)",
        "--popup-icon-color": "#0E1311",

        /*Tooltip styles:*/
        "--tooltip-bg-color": "#0E1311",
        "--tooltip-text-color": "#ffffff",
      },
    };

    const handleScriptLoad = () => {
      window?.carouselInlineWidget("reviewsio-carousel-widget", options);
    };

    script.addEventListener("load", handleScriptLoad);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
      script.removeEventListener("load", handleScriptLoad);
      document.body.removeChild(script);
    };
  }, []);

  const [keyConvertToUpperCase, setKeyConvertToUpperCase] = useState("");
  const onSearchingHandler = (e) => {
    console.log(e.target.value);
    e?.preventDefault();
    const val = e.target.value;
    const regexPattern = /^[A-Za-z0-9 ]*$/;
    if (regexPattern.test(val) && val.length <= 9) {
      setKeyConvertToUpperCase(val.trimStart().toUpperCase());
      setSearchKey(val.trimStart().toLowerCase());
    }
  };

  const onSearch = (e) => {
    e?.preventDefault();
    if (searchKey) {
      navigate(`/search-results/${searchKey}`, { state: { searchKey: searchKey } });
    }
  };

  const getHomeData = () => {
    API("home", "get", "", "")
      .then((res) => {
        console.log("home res: ", res?.data);
        setHomeData(res?.data);
      })
      .catch((e) => console.log("erro home: ", e));
  };

  return (
    <Suspense fallback={<Loader />}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Home</title>
      </Helmet>
      <div className="main__page__content ">
        <main>
          <section className="reg__hero--section d-flex align-center" style={{backgroundImage: `url(${homeData?.banner?.image})`}}>
            <div className="container">
              <div className="row align-center">
                <div className="col-6">
                  <div className="reg__car--image">
                    <img src={car1} alt="image" />
                  </div>
                </div>
                <div className="col-6">
                  <div className="reg__car--detailss br20 color-white">
                    <div className="reg__car--title">
                      <h1 className="text-300 f40 text-left fys lh60 mb-20">
                        Discover your perfect plate today
                      </h1>
                      <form className="d-flex justify-between mb-23">
                        <span
                          className={
                            keyConvertToUpperCase
                              ? ""
                              : "custom-input-container"
                          }
                        >
                          <input
                            className="custom-input form-control fun f40"
                            type="search"
                            placeholder=""
                            aria-label="Search"
                            value={keyConvertToUpperCase}
                            onChange={onSearchingHandler}
                          />
                        </span>
                        <button
                          className="reg__search--button btn btn-outline-success green-section border-0 rounded-0"
                          onClick={onSearch}
                        >
                          <img className="w-32 h-32" src={search} alt="image" />
                        </button>
                      </form>
                      <a
                        href="tel:01582347734"
                        className="text-white d-flex hero-number justify-center align-center fsi text-400 mb-23"
                      >
                        <img
                          className="in-svg mr-5 d-inline w-auto"
                          src={bordercall}
                          alt="image"
                        />
                        01582 347734
                      </a>
                      <div className="reg__bs--button">
                        <div className="reg__buy--button d-flex align-center justify-center g25">
                          <button className="buy d-flex align-items-center f-14 justify-content-between" onClick={() => navigate("/buy-registrations")}>
                            BUY
                            <svg
                              width="36"
                              height="8"
                              viewBox="0 0 36 8"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M35.3536 4.35355C35.5488 4.15829 35.5488 3.84171 35.3536 3.64645L32.1716 0.464466C31.9763 0.269204 31.6597 0.269204 31.4645 0.464466C31.2692 0.659728 31.2692 0.976311 31.4645 1.17157L34.2929 4L31.4645 6.82843C31.2692 7.02369 31.2692 7.34027 31.4645 7.53553C31.6597 7.7308 31.9763 7.7308 32.1716 7.53553L35.3536 4.35355ZM0 4.5H35V3.5H0V4.5Z"
                                fill="black"
                              />
                            </svg>
                          </button> 
                          <button
                            className="sell d-flex align-items-center f-14 justify-content-between"
                            onClick={() => navigate("/sell-number-plate")}
                          >
                            SELL
                            {/* <img src={arrow} alt="image" /> */}
                            <svg
                              width="36"
                              height="8"
                              viewBox="0 0 36 8"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M35.3536 4.35355C35.5488 4.15829 35.5488 3.84171 35.3536 3.64645L32.1716 0.464466C31.9763 0.269204 31.6597 0.269204 31.4645 0.464466C31.2692 0.659728 31.2692 0.976311 31.4645 1.17157L34.2929 4L31.4645 6.82843C31.2692 7.02369 31.2692 7.34027 31.4645 7.53553C31.6597 7.7308 31.9763 7.7308 32.1716 7.53553L35.3536 4.35355ZM0 4.5H35V3.5H0V4.5Z"
                                fill="black"
                              />
                            </svg>
                          </button>
                        </div>
                        <p className="text-center mt-15 fys mb-0">
                          Service that never stops.
                        </p>
                        <div className="reg__sell--button"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div className="reg__review--section">
            <div className="container">
              <div className="reg__review--data">
                <div className="row align-center">
                  <div id="reviewsio-carousel-widget"></div>
                </div>
              </div>
            </div>
          </div>
          <section className="reg__dvla--section pb-60 pt-55">
            {homeData?.bullets?.map((item, index) =>
              index % 2 === 0 ? (
                <div
                  className={
                    homeData?.bullets?.length - 1 === index
                      ? "container"
                      : "container mb-70"
                  }
                >
                  <div className="row align-center">
                    <div className="col-4">
                      <div className="car-image">
                        <img
                          className="b-full"
                          src={item?.image_url}
                          alt="image"
                        />
                      </div>
                    </div>
                    <div className="col-8 pr-45">
                      <div className="car--data">
                        <h2 className="text-300 f30 fys mb-20 lh45">
                          {item?.main_title}
                        </h2>
                        <div className="car-inner d-flex fsi">
                          {/* <p>{item?.title}</p> */}
                          <p
                            dangerouslySetInnerHTML={{
                              __html: item?.title,
                            }}
                          />
                          <p
                            dangerouslySetInnerHTML={{
                              __html: item?.bullets[0],
                            }}
                            className="pl-30 fsi"
                          />
                          {/* <ul className="pl-30">
                            {item?.bullets?.map((bullet) => (
                              <li>
                                {'\u2022'} {bullet}
                              </li>
                            ))}
                          </ul> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  className={
                    homeData?.bullets?.length - 1 === index
                      ? "container"
                      : "container mb-70"
                  }
                >
                  <div className="row align-center">
                    <div className="col-8 pr-45">
                      <div className="car--data">
                        <h2 className="text-300 f30 fys mb-20 lh45">
                          {item?.main_title}
                        </h2>
                        <div className="car-inner d-flex fsi">
                          <p
                            dangerouslySetInnerHTML={{
                              __html: item?.title,
                            }}
                          />
                          <p
                            dangerouslySetInnerHTML={{
                              __html: item?.bullets[0],
                            }}
                            className="pl-30 fsi"
                          />
                          {/* <p>{item?.title}</p> */}
                          {/* <ul className="pl-30">
                            {item?.bullets?.map((bullet) => (
                              <li>
                                {'\u2022'} {bullet}
                              </li>
                            ))}
                          </ul> */}
                        </div>
                      </div>
                    </div>
                    <div className="col-4">
                      <div className="car-image">
                        <img
                          className="b-full"
                          src={item?.image_url}
                          alt="image"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )
            )}

            {/* img2 */}

            {/* <div className="container">
            <div className="row align-center">
              <div className="col-4">
                <div className="car-image">
                  <img className="b-full" src={homeData?.bullets[2]?.image_url} alt="image" />
                </div>
              </div>
              <div className="col-8 pr-45">
                <div className="car--data">
                  <h4 className="text-300 fys mb-20 lh28">
                  {homeData?.bullets[2]?.title}
                  </h4>
                  <div className="car-inner fsi">
                    <ul className="pl-30">
                    {homeData?.bullets[2]?.bullets?.map(item => (
                        <li>{item}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          </section>
          <section className="reg__registrations--section">
            <div className="container">
              <div className="reg__registrations--title mb-50">
                <h2 className="f32 fys text-300 black-text text-center">
                  Registrations Featured
                </h2>
              </div>
              <div className="reg__number--plate regswiper regmySwiper">
                {/* removed "swiper-wrapper" class */}
                {windowSize[0] <= 991 ? (
                  <Swiper
                    // install Swiper modules
                    modules={[Navigation, Pagination, Scrollbar, A11y]}
                    spaceBetween={16}
                    slidesPerView={
                      windowSize[0] <= 991 && windowSize[0] >= 867
                        ? 3
                        : windowSize[0] < 867 && windowSize[0] >= 312
                        ? 2
                        : 1
                    }
                    navigation={{
                      prevEl: "swiper-button-prev",
                      nextEl: "swiper-button-next",
                    }}
                    observeParents
                    observer
                    parallax
                    // pagination={{ clickable: true }}
                    // scrollbar={{ draggable: true }}
                    onSwiper={(swiper) => {
                      swiperRef.current = swiper;
                    }}
                    onSlideChange={() => console.log("slide change")}
                  >
                    {homeData?.Featured?.map((item, index) => (
                      <SwiperSlide className="col-3" key={index} onClick={() => navigate(`/checkout/${item?.reg}`)}>
                        <div className="reg__plate--data fun yellow-bg br4 mb-5">
                          <h2>{item?.reg}</h2>
                        </div>
                        <div className="reg__number--price d-flex align-center justify-between">
                          <Link
                            className="fsi f-14 gray-text text-uppercase"
                            to={`/checkout/${item?.reg}`}
                          >
                            View
                          </Link>
                          <span className="price fun text-300">
                            £{item?.sales}
                          </span>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                ) : (
                  <div className="row row-gap-10">
                    {homeData?.Featured?.map((item, index) => (
                      <div role="button" className="col-3" key={index} onClick={() => navigate(`/checkout/${item?.reg}`)}>
                        <div className="reg__plate--data fun yellow-bg br4 mb-5">
                          <h2>{item?.reg}</h2>
                        </div>
                        <div className="reg__number--price d-flex align-center justify-between">
                          <Link
                            className="fsi f-14 gray-text text-uppercase"
                            to={`/checkout/${item?.reg}`}
                          >
                            View
                          </Link>
                          <span className="price fun text-300">
                            £{item?.sales}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                <div className="reg__slider--button justify-center">
                  <div
                    className="swiper-button-prev"
                    onClick={() => swiperRef.current.slidePrev()}
                  ></div>
                  <div
                    className="swiper-button-next"
                    onClick={() => swiperRef.current.slideNext()}
                  ></div>
                </div>
              </div>
            </div>
          </section>
          <section className="reg__whychoose--section">
            <div className="container">
              <div className="reg__whychoose--inner">
                <div className="row row-gap-24">
                  <div className="col-12 mb-25">
                    <div className="reg__choose--text reg__choose--data-box position-relative">
                      <h3 className="f20 text-700 mb-20 fys text-700">
                        {homeData?.homedata[2]?.title}
                      </h3>
                      <p className="text-400 lh24 mb-0 fsi">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: homeData?.homedata[2]?.description,
                          }}
                        />
                        {/* {homeData?.homedata[2]?.description} */}
                      </p>
                    </div>
                  </div>
                  <div className="col-12 mb-25">
                    <div className="reg__choose--data-box position-relative d-flex">
                      <div className="reg__data--image">
                        <img src={cardpay} alt="image" />
                      </div>
                      <div className="reg__data--text">
                        <div className="reg__data--text-title">
                          <div class="reg__image--posion"></div>
                          <h3 className="f20 text-700 mb-20 fys text-700">
                            {homeData?.homedata[0]?.title}
                          </h3>
                        </div>
                        <p className="text-400 lh24 mb-0 fsi">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: homeData?.homedata[0]?.description,
                            }}
                          />
                          {/* {homeData?.homedata[0]?.description} */}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 mb-25">
                    <div className="reg__choose--data-box position-relative d-flex">
                      <div className="reg__data--image">
                        <img src={solardiploma} alt="image" />
                      </div>
                      <div className="reg__data--text">
                        <div className="reg__data--text-title">
                          <div className="reg__image--posion"></div>
                          <h3 className="f20 text-700 mb-20 fys text-700">
                            {homeData?.homedata[1]?.title}
                          </h3>
                        </div>
                        <p className="text-400 lh24 mb-0 fsi">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: homeData?.homedata[1]?.description,
                            }}
                          />
                          {/* {homeData?.homedata[1]?.description} */}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
    </Suspense>
  );
};

export default Home;
